// Hook que expone la session admin reactivamente al shell y a las pages.
//
// Se suscribe al store central (lib/api.ts). No refetchea — el hook
// useProfile (TanStack Query) es el que hace polling/refetch si hace falta.

import { useEffect, useState } from 'react';
import { getSession, subscribeSession, type AdminSession } from '@/lib/api';

export function useSession(): AdminSession | null {
  const [session, setSessionState] = useState<AdminSession | null>(() => getSession());

  useEffect(() => {
    const unsub = subscribeSession(setSessionState);
    return () => {
      unsub();
    };
  }, []);

  return session;
}
